module.exports = __webpack_public_path__ + "static/img/2_1.5329257f.jpg";